var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxMegaphoneOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.009 3a1 1 0 00-.707.293c-.125.125-.223.24-.293.344C16.3 5.754 14.72 5.97 12 5.98h-1.192l2 2c2.08 0 3.447-.057 5.2-1.502v6.702l2 2V4a1 1 0 00-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.534 6.363l-1.02-1.02A1 1 0 015.93 3.93L20.07 18.07a1 1 0 01-1.414 1.414l-5.125-5.124-1.613 5.012a.999.999 0 01-.919.607H7a1 1 0 01-.919-1.394l1.403-4.606H7a3.003 3.003 0 01-3-3v-2a3.002 3.002 0 011.534-2.617zm5.617 5.617H9V9.828l2.151 2.152zM6 10.98v-2a1 1 0 011-1v4a1 1 0 01-1-1zm4.34 7H8.518l1.142-4h1.824l-1.142 4z",
    clipRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxMegaphoneOff);
export default __webpack_public_path__ + "static/media/4-icon-24-px-megaphone-off.b79726ae.svg";
export { ForwardRef as ReactComponent };